import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

const useBreakpoint = () => {
    const theme = useTheme();

    const breakpoints: Record<Breakpoint, boolean> = {
        xs: useMediaQuery(theme.breakpoints.only('xs')),
        sm: useMediaQuery(theme.breakpoints.only('sm')),
        md: useMediaQuery(theme.breakpoints.only('md')),
        lg: useMediaQuery(theme.breakpoints.only('lg')),
        xl: useMediaQuery(theme.breakpoints.only('xl')),
    };

    const getBreakPointName = (): Breakpoint | null => {
        return (
            (Object.keys(breakpoints) as Breakpoint[]).find(
                (key) => breakpoints[key] === true,
            ) || null
        );
    };

    const isBreakPoint = (breakpoint: string) => {
        return getBreakPointName() === breakpoint;
    };

    const betweenBreakPoint = (...breakpoints: Array<string>) => {
        const breakPoint = breakpoints.map(
            (breakpoint: string) => getBreakPointName() === breakpoint,
        );

        return breakPoint.find((value) => value === true) || false;
    };

    const biggerThan = (breakpoint: Breakpoint) => {
        const currentBreakPoint: Breakpoint | null = getBreakPointName();
        if (!currentBreakPoint) return;

        const keys = Object.keys(breakpoints) as Breakpoint[];

        const currentBreakPointIndex = keys.findIndex(
            (key) => key === currentBreakPoint,
        );
        const breakPointIndex = keys.findIndex((key) => key === breakpoint);

        return currentBreakPointIndex > breakPointIndex;
    };

    const lowerThan = (breakpoint: Breakpoint) => {
        return !biggerThan(breakpoint);
    };

    return {
        getBreakPointName,
        isBreakPoint,
        betweenBreakPoint,
        biggerThan,
        lowerThan,
    };
};

export default useBreakpoint;
